

import {
    CREATE,
    DELETE,
    DELETE_MANY,
    GET_LIST,
    GET_MANY,
    GET_MANY_REFERENCE,
    GET_ONE,
    UPDATE,
    UPDATE_MANY,
} from "react-admin";
import CheckInStore from "../stores/CheckInStore2";
import StationSetupStore from "../stores/StationSetupStore";
import StationAdoptStore from "./StationAdoptStore";


const getOne = async ()=> {
    return new StationAdoptStore().read();
}

const save = async (data)=> {
    var result = new StationAdoptStore().save(data);
    return result;
}

const deleteOne = async (data)=> {
    var result = new StationAdoptStore().remove(data.data);
    return result;
}


export async function StationAdoptDataProvider(
    type,
    resourceName,
    params
) {
    console.log("Provider: event", {type, resourceName, params});
    try {
        switch (type) {
            case GET_MANY:
                return getOne();
                break;
            case GET_MANY_REFERENCE:
                return getOne();
            case GET_LIST:
                return getOne();
            case GET_ONE:
                return getOne();
            case CREATE:
                return save(params);
            case UPDATE:
                return save(params);
            case UPDATE_MANY:
                return getOne();
            case DELETE:
                return deleteOne();
            case DELETE_MANY:
                return deleteOne();
            default:
                throw new Error(`Unknkown dataprovider command type: "${type}"`);
        }
    } catch (error) {
        console.log('CheckInDataProvider error');
        console.log(error);
        throw error;
    }
}